import React, { useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  SxProps,
} from '@mui/material';
import {
  COLOR_PRIMARY_2,
  COLOR_TEXT_2,
  COLOR_BORDER,
  COLOR_CARD_SHADOW,
} from 'src/utils/colors';
import { parseText } from 'src/App/Dashboards/Market/Components/Text/utils';

interface SubmarketInfoTextProps {
  isMobileView: boolean;
  handleOnSampleClick: (plan: string) => void;
  sx?: SxProps;
  submarketSummary: any;
  TopSubmarketGraphComponent: React.ReactNode;
  formattedSubmarketSummary?: any;
}

const DEMO_TEXT =
  'Top submarkets include *Jabal Ali Second, Dubai* and *Al Wasl, Dubai*, both earning the highest neighborhood grades. *Al Muteena, Dubai* is showing upward momentum, while *Al Thanyah  Fourth, Dubai* stands out as a promising area for the luxury segment.';

const SubmarketInfoText = ({
  submarketSummary,
  isMobileView,
  handleOnSampleClick,
  sx,
  TopSubmarketGraphComponent,
  formattedSubmarketSummary,
}: SubmarketInfoTextProps) => {
  useEffect(() => {
    if(formattedSubmarketSummary ){
      formattedSubmarketSummary.current = parseText(submarketSummary, handleOnSampleClick, 'text');
    }
  }, [submarketSummary]);

  return (
    <Card
      sx={{
        background: '#fff',
        borderRadius: 3,
        boxShadow: COLOR_CARD_SHADOW,
        border: `1px solid ${COLOR_BORDER}`,
        overflow: 'visible',
        position: 'relative',
        p: 0,
        m: 0,
        minHeight: (isMobileView ? 70 : 100) + 32,
        width: '100%',
        maxWidth: '100vw',
        pb: 0,
        // Top border accent
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: COLOR_PRIMARY_2,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          zIndex: 2,
        },
        ...sx,
      }}
    >
      <CardContent sx={{ p: 2, pt: 4, pr: isMobileView ? 2 : 6, pb: '0 !important' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobileView ? 'flex-start' : 'center',
            gap: 2,
            width: '100%',
          }}
        >
          {/* AI Summary Text */}
          <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
            {/* Market Summary Lines as bullet points */}
            <Box sx={{ pl: 3, mb: 1, mt: 0, listStyle: 'disc', color: COLOR_TEXT_2 }}>
              <Typography variant="body1" sx={{ color: COLOR_TEXT_2 }}>
                {parseText(submarketSummary, handleOnSampleClick)}
              </Typography>
            </Box>
          </Box>

          {TopSubmarketGraphComponent}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SubmarketInfoText;
